import * as React from 'react';
import { Row, Button } from 'react-bootstrap';
import { Field } from 'redux-form';
import { FormattedNumber } from 'react-intl';
import Benefit from '../Benefit';
import Signpost from '../../../SchemeChoice/components/Signpost';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { isRequired } from '../../../../../../util/validators';

interface IQuoteCardProps {
    containerClassName: string;
    backgroundColor: string;
    title: string;
    schemeTypeLabel: string;
    gross: number;
    currency: string;
    schemeId: string;
    selectedSchemeId: string;
    onSchemeChange: any;
    standardExcess: any;
    benefitsFlatten: any[];
    breakingPoint: number;
    moreInfo: boolean;
    moreInfoSign: string;
    toggleMoreInfo: () => void;
    downloadDocument: (docs: any) => () => void;
    documents: any;
    signpost: any;
    channel: any;
    getBenefitText: (benefits: any[], displayName: any, type?: any, subBenefitName?: any) => any;
    upsell?: {
        schemeTypeLabel: string;
        gross: number;
        currency: string;
        schemeId: string;
    };
}

export default class QuoteCard extends React.PureComponent<IQuoteCardProps> {
    public renderBenefitList() {
        const p = this.props;
        const benefitsFlatten = p.benefitsFlatten || [];
        return benefitsFlatten.map((benefit: any, idx: number) => {
            if (idx === p.breakingPoint) {
                return (
                    <div key={idx} id="view-document-section">
                        <Benefit
                            title={benefit.name}
                            description={p.getBenefitText(benefitsFlatten, benefit.name, 'description')}
                            value={p.getBenefitText(benefitsFlatten, benefit.name)}
                            hasSubBenefits={benefit.hasSubBenefits}
                            subBenefits={benefit.subBenefits}
                        />

                        <div className="view-document-container">
                            <div className="quote-section"
                                 style={{
                                     display: 'flex',
                                     flexDirection: 'column',
                                     alignItems: 'center',
                                     paddingTop: '20px',
                                     paddingBottom: '20px',
                                     marginBottom: '10px',
                                 }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        height: '40px',
                                        alignItems: 'center',
                                        fontSize: '14px',
                                        marginBottom: '10px',
                                    }}>
                                    <Button
                                        className="view-btn btn-remove-border"
                                        block={true}
                                        onClick={p.downloadDocument(p.documents)}
                                    >
                                        VIEW
                                    </Button>
                            </div>
                        </div>
                        <div className="view-document-container">
                            <div className="quote-section"
                                 style={{
                                     display: 'flex',
                                     flexDirection: 'column',
                                     alignItems: 'center',
                                     paddingTop: '20px',
                                     paddingBottom: '20px',
                                     marginBottom: '10px',
                                 }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        height: '40px',
                                        alignItems: 'center',
                                        fontSize: '30px',
                                        marginBottom: '10px',
                                    }}>
                                        <span className={'glyphicon ' + p.moreInfoSign} onClick={p.toggleMoreInfo}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                );
            }

            if (idx > p.breakingPoint) {
                if (!p.moreInfo) { return null; }
                return (
                    <div key={idx}>
                        <Benefit
                            title={benefit.name}
                            description={p.getBenefitText(benefitsFlatten, benefit.name, 'description')}
                            value={p.getBenefitText(benefitsFlatten, benefit.name)}
                            hasSubBenefits={benefit.hasSubBenefits}
                            subBenefits={benefit.subBenefits}
                        />
                    </div>
                );
            }

            return (
                <Benefit
                    key={idx}
                    title={benefit.name}
                    description={p.getBenefitText(benefitsFlatten, benefit.name, 'description')}
                    value={p.getBenefitText(benefitsFlatten, benefit.name)}
                    hasSubBenefits={benefit.hasSubBenefits}
                    subBenefits={benefit.subBenefits}
                />
            );
        });
    }

    public render() {
        const p = this.props;
        const isSelected = p.schemeId === p.selectedSchemeId;
        const upsellSelected = !!p.upsell && p.upsell.schemeId === p.selectedSchemeId;

        return (
            <div className={p.containerClassName} style={{ backgroundColor: p.backgroundColor }}>
                <div className="quote-header">
                    <p className="cover-level">{p.title}</p>
                </div>

                <div className="quote-body">
                    <div>
                        <span className="scheme-type">{p.schemeTypeLabel}</span>
                        <h1>
                            <FormattedNumber value={p.gross} style="currency" currency={p.currency} />
                        </h1>

                        <Field
                            name="schemeId"
                            type="radio"
                            value={p.schemeId}
                            className="select-quote"
                            component={FieldFormControl}
                            validate={[isRequired]}
                            onChange={p.onSchemeChange}
                        >
                            <div
                                className="select-quote-btn"
                            >
                                {isSelected ? 'Selected' : 'Select'}
                            </div>
                        </Field>
                    </div>

                    {p.upsell && (
                        <div className="annual-quotes">
                            <span className="scheme-type">{p.upsell.schemeTypeLabel}</span>
                            <h1>
                                <FormattedNumber
                                    value={p.upsell.gross}
                                    style="currency"
                                    currency={p.upsell.currency}
                                />
                            </h1>

                            <Field
                                name="schemeId"
                                type="radio"
                                value={p.upsell.schemeId}
                                className="select-quote"
                                component={FieldFormControl}
                                validate={[isRequired]}
                                onChange={p.onSchemeChange}
                            >
                                <div
                                    className="select-quote-btn"
                                    style={{ backgroundColor: upsellSelected ? '#4d2973' : '#82a7c7' }}
                                >
                                    {upsellSelected ? 'Selected' : 'Select'}
                                </div>
                            </Field>
                        </div>
                    )}

                    {!!p.signpost && (
                        <Row>
                            <Signpost signpost={p.signpost} channel={p.channel} />
                        </Row>
                    )}

                    <Row className="benefit-section">
                        <Benefit title={'Standard Excess'} description={null} value={p.standardExcess} />
                        {this.renderBenefitList()}
                    </Row>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/SchemeChoiceB/components/QuoteCard/index.tsx